import { styled } from '@mui/material/styles';

import { Badge as SharedBadge } from 'shared/components/Badge';

import type { BadgeProps as MuiBadgeProps } from '@mui/material';

interface BadgeProps extends MuiBadgeProps {
  isOnline?: boolean;
}

export const Badge = styled(SharedBadge, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'isOnline',
})<BadgeProps>(({ theme, isOnline }) => ({
  '& .MuiBadge-badge': {
    bottom: '4px',
    right: '4px',
    backgroundColor: isOnline
      ? `${theme.palette.success.light}`
      : `${theme.palette.error.main}`,
    // TODO: Think to create custom component
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));
